import React from 'react';
import PropTypes from 'prop-types';

function Img(props) {
  return <img src={props.src} alt={props.alt} />;
}

// We require the use of src and alt, only enforced by react in dev mode
Img.propTypes = {
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  alt: PropTypes.string.isRequired
};

export default Img;
